import * as Yup from 'yup';

export default () =>
  Yup.object().shape({
    title: Yup.string().required('Field is required'),
    link: Yup.string().required('Field is required'),
  });
